import React from 'react';
import Image from '@/components/common/Image';
import { Button } from '@/components/common/Button/Button';
import { cn } from '@/utils/cn';

interface CaseStudyProps {
  title: string;
  description: string;
  personName: string;
  personTitle: string;
  buttonText: string;
  buttonUrl: string;
  imageSrc: string;
  imageAlt: string;
  backgroundColor?: string;
  className?: string;
}

export const CaseStudy: React.FC<CaseStudyProps> = ({
  title,
  description,
  personName,
  personTitle,
  buttonText,
  buttonUrl,
  imageSrc,
  imageAlt,
  backgroundColor = "#f2f6ff",
  className
}) => {
  return (
    <section className={cn("py-12 md:pb-20 my-5", className)}>
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Mobile view - stacked layout */}
          <div className="block md:hidden">
            <div className={`bg-[${backgroundColor}] rounded-xl p-8`}>
              <h2 className="text-2xl font-bold text-center mb-4">{title}</h2>
              <p className="text-gray-700 text-center mb-6">
                {description}
              </p>
              <div className="text-center mb-6">
                <p className="font-medium text-lg">{personName}</p>
                <p className="text-gray-500">{personTitle}</p>
              </div>
              <div className="flex justify-center mb-8">
                <Button
                  variant="solid"
                  color="primary"
                  onClick={() => {
                    window.open(buttonUrl, '_blank');
                  }}
                >
                  {buttonText}
                </Button>
              </div>
              <div className="relative">
                <Image
                  src={imageSrc}
                  alt={imageAlt}
                  className="w-full rounded-lg object-contain"
                  width={500}
                  height={300}
                />
              </div>
            </div>
          </div>

          {/* Desktop view - side by side layout */}
          <div className="hidden md:block">
            <div className={`bg-[${backgroundColor}] rounded-xl p-12 flex items-center`}>
              <div className="w-1/2 pr-16 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-6">{title}</h2>
                <p className="text-gray-700 mb-8">
                  {description}
                </p>
                <div className="mb-8">
                  <p className="font-medium text-lg">{personName}</p>
                  <p className="text-gray-500">{personTitle}</p>
                </div>
                <div>
                  <Button
                    variant="solid"
                    color="primary"
                    onClick={() => {
                      window.open(buttonUrl, '_blank');
                    }}
                  >
                    {buttonText}
                  </Button>
                </div>
              </div>
              <div className="w-1/2">
                <Image
                  src={imageSrc}
                  alt={imageAlt}
                  className="w-full rounded-lg object-cover"
                  width={600}
                  height={400}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};